// FDA "Big 9" major food allergens.
// See https://www.fda.gov/food/food-labeling-nutrition/food-allergies
export const ALLERGENS = [
  { id: "milk", label: "Milk" },
  { id: "eggs", label: "Eggs" },
  { id: "fish", label: "Fish" },
  { id: "shellfish", label: "Shellfish" },
  { id: "tree_nuts", label: "Tree nuts" },
  { id: "peanuts", label: "Peanuts" },
  { id: "wheat", label: "Wheat" },
  { id: "soy", label: "Soy" },
  { id: "sesame", label: "Sesame" },
] as const;

export type AllergenId = (typeof ALLERGENS)[number]["id"];

// The legacy allergen id that must be split by cooks into tree_nuts and/or peanuts.
export const LEGACY_NUTS_ID = "nuts";

// Labels for the current set plus legacy ids we still need to render on old data.
const LABELS: Record<string, string> = {
  ...Object.fromEntries(ALLERGENS.map((a) => [a.id, a.label])),
  // Legacy ids that may still appear on older dishes until cooks re-review.
  nuts: "Nuts (legacy — needs review)",
  gluten: "Wheat",
  dairy: "Milk",
};

export function allergenLabel(id: string): string {
  return LABELS[id] ?? id;
}

// True if a dish's allergen list still contains ambiguous legacy tags that
// need a cook to reclassify under the FDA-9 scheme.
export function allergensNeedReview(allergens: readonly string[] | null | undefined): boolean {
  if (!allergens) return false;
  return allergens.includes(LEGACY_NUTS_ID);
}
